export default "__VITE_ASSET__CLjWvbkU__"